import { render } from "./TooltipColor.vue?vue&type=template&id=a3ba094e"
import script from "./TooltipColor.vue?vue&type=script&lang=js"
export * from "./TooltipColor.vue?vue&type=script&lang=js"

import "./TooltipColor.vue?vue&type=style&index=0&id=a3ba094e&lang=css"

import exportComponent from "/home/forge/loewe-zaun-live-56lid4vr.on-forge.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__